import { render, staticRenderFns } from "./LiftPost.vue?vue&type=template&id=83edbc94&scoped=true&"
import script from "./LiftPost.vue?vue&type=script&lang=js&"
export * from "./LiftPost.vue?vue&type=script&lang=js&"
import style0 from "./LiftPost.vue?vue&type=style&index=0&id=83edbc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83edbc94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout})
